export default "__VITE_ASSET__7IWNTEmx__"